import type { ShipmentDocument } from "api";
import { documentFileUrl } from "api";
import { DownloadIcon, EyeIcon, FileIcon, TrashIcon } from "./docs.icons";

type DocumentItemProps = {
  document: ShipmentDocument;
  /** Name the container too — for lists that mix shipment and container documents. */
  showContainer?: boolean;
  onDelete: (document: ShipmentDocument) => void;
};

/** One `.shdoc__i` row: the file, what it is, and preview / download / delete. */
export const DocumentItem = ({ document, showContainer = false, onDelete }: DocumentItemProps) => (
  <div className="shdoc__i">
    <span className="shdoc__ico">
      <FileIcon />
    </span>
    <span className="shdoc__n">
      <b>
        {document.name}
        {showContainer && document.container_number !== null && (
          <span className="shdoc__chip">{document.container_number}</span>
        )}
      </b>
      <em>
        {document.original_name} · {document.size_label}
      </em>
    </span>
    <div className="shdoc__acts">
      {/* Links rather than buttons: the session cookie travels with them, and
          the back office decides between showing and downloading. No
          `noreferrer`: Sanctum only treats a request with a Referer from a
          stateful domain as signed in, so without one the preview is a 401. */}
      <a
        className="shdoc__a"
        href={documentFileUrl(document, true)}
        target="_blank"
        rel="noopener"
        aria-label={`Preview ${document.name}`}
      >
        <EyeIcon />
      </a>
      <a className="shdoc__a" href={documentFileUrl(document)} download aria-label={`Download ${document.name}`}>
        <DownloadIcon />
      </a>
      <button
        type="button"
        className="shdoc__a shdoc__a--del"
        aria-label={`Delete ${document.name}`}
        onClick={() => onDelete(document)}
      >
        <TrashIcon />
      </button>
    </div>
  </div>
);
